import { UPPER_THRESHOLD } from '../constants/StringConstants';

export const getBalanceRequestPacket = (enable, amount, alertId) => {
  let balanceRequestPacket;
  const threshold = {
    enabled: enable,
    amount: {
      value: parseFloat(amount),
      currency: 'GBP',
    },
  };
  if (alertId === UPPER_THRESHOLD) {
    balanceRequestPacket = {
      alerts: [
        {
          upper_threshold: {
            ...threshold,
          },
        },
      ],
    };
  } else {
    balanceRequestPacket = {
      alerts: [
        {
          lower_threshold: {
            ...threshold,
          },
        },
      ],
    };
  }
  return balanceRequestPacket;
};

export const getSweepRequestPacket = (
  targetAmount,
  thresholdAmount,
  sweepEnabled,
  savingAccountsId
) => {
  const sweepRequestPacket = {
    direction: 'in',
    threshold: {
      value: parseFloat(thresholdAmount),
      currency: 'GBP',
    },
    target: {
      value: parseFloat(targetAmount),
      currency: 'GBP',
    },
    other_account_id: savingAccountsId,
    enabled: sweepEnabled,
  };
  return sweepRequestPacket;
};
export const getProjectionRequestPacket = (projectionEnable, projectionAmount) => {
  const projectionRequestPacket = {
    thresholds: {
      lower: {
        amount: {
          value: parseFloat(projectionAmount),
          currency: 'GBP',
        },
      },
    },
    external_notification: projectionEnable,
  };
  return projectionRequestPacket;
};
export const getTransactionBalRequestPacket = (
  transactionAmountEnable,
  transactionAmount,
  incomingTransactionValidation
) => {
  let balanceRequestPacket;
  const amountThreshold = {
    amount: {
      amount: {
        value: parseFloat(transactionAmount),
        currency: 'GBP',
      },
      enabled: transactionAmountEnable,
    },
  };
  if (incomingTransactionValidation) {
    balanceRequestPacket = {
      credit_alert: [
        {
          ...amountThreshold,
        },
      ],
    };
  } else {
    balanceRequestPacket = {
      debit_alert: [
        {
          ...amountThreshold,
        },
      ],
    };
  }
  return balanceRequestPacket;
};
export const getTransactionToggleRequestPacket = (enableType, isEnabled) => {
  const requestObj = {};
  requestObj[enableType] = { enabled: isEnabled };
  return {
    debit_alert: [requestObj],
  };
};
export const getTransactionMethodOFF = (isEnabled) => {
  const requestPacket = {
    debit_alert: [
      { internet: { enabled: isEnabled } },
      { atm: { enabled: isEnabled } },
      { pos: { enabled: isEnabled } },
      { manual: { enabled: isEnabled } },
    ],
  };
  return requestPacket;
};
export const updateArrangedOverdraftRequestPacket = (enabled) => ({
  alerts: [
    {
      type: 'overdraft',
      enabled,
    },
  ],
});
